export default __webpack_public_path__ + "static/media/sortingIconAscending.e8b8e4df.svg";